import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/services/Admin/admin.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-add-role',
  templateUrl: './add-role.component.html',
  styleUrls: ['./add-role.component.css']
})
export class AddRoleComponent implements OnInit {


  Submitted=false;
  AddRoleList=[];
  constructor(private adminservice: AdminService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

    AddRoleModel = {
      RoleID: 0,       
      RoleName: '',
      UserTypeID: 3,
      RoleCode: '',
      IsActive: true
  }

  ValidateDropdown() {
      return this.AddRoleModel.UserTypeID == 0;
  };

  Clear() {
      this.Submitted = false;
      this.AddRoleModel.RoleName = '';
      this.AddRoleModel.RoleCode = '';
      this.AddRoleModel.UserTypeID = 0;    
  };

  SaveBranchAddRole(valid) {
     
      this.Submitted = true;
      if (valid ) {

          for (var i = 0; i < this.AddRoleList.length; i++) {
              if (this.AddRoleModel.UserTypeID == this.AddRoleList[i].UserTypeID) {

                 if ((this.AddRoleList[i].RoleName == this.AddRoleModel.RoleName && this.AddRoleList[i].RoleID != this.AddRoleModel.RoleID) || (this.AddRoleList[i].RoleCode == this.AddRoleModel.RoleCode && this.AddRoleList[i].RoleID != this.AddRoleModel.RoleID)) {
                  alert('Role Name or Role Code Already Exists')
                  return false;
              }
          }
             
          }
       
          this.spinnerService.show();
          this.adminservice.SaveBranchRole(JSON.stringify(this.AddRoleModel)).subscribe((data: any) => {
            this.globalHelper.CheckActionStatus(data);
              this.spinnerService.hide();
              this.BindBranchRole();
              this.Clear();
          });
      }
  };
  RoleMarkActive(item) {
      this.AddRoleModel.RoleID = item.RoleID;
      this.AddRoleModel.IsActive = item.IsActive == true ? false : true;
      this.spinnerService.show();
      this.adminservice.RoleMarkActive(JSON.stringify(this.AddRoleModel)).subscribe((data: any) => {
          this.BindBranchRole();
          this.spinnerService.hide();
          this.globalHelper.CheckActionStatus(data);
          this.Clear();


      });
  }

  BindBranchRole() {
    this.spinnerService.show();
      this.adminservice.BindBranchRole().subscribe((data: any) => {
          this.AddRoleList = data.RoleList;
          this.spinnerService.hide();
      });
  };


  Edit(obj) {
      this.AddRoleModel.RoleID = obj.RoleID;
      this.AddRoleModel.RoleCode = obj.RoleCode;
      this.AddRoleModel.RoleName = obj.RoleName;
      this.AddRoleModel.IsActive = obj.IsActive;
      this.AddRoleModel.UserTypeID =3;
  };


  ngOnInit() {
    this.BindBranchRole();
  }

}
